import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Search, ShoppingCart, MessageSquare, User, Package, Store, LayoutDashboard } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const BottomNav = ({ cartCount = 0 }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user) { setUnread(0); return; }
    const load = async () => {
      try {
        const token = localStorage.getItem('dz_token');
        const [r1, r2] = await Promise.all([
          fetch((process.env.REACT_APP_BACKEND_URL || '') + '/api/messages/unread-count', { headers: { 'Authorization': 'Bearer ' + token } }),
          fetch((process.env.REACT_APP_BACKEND_URL || '') + '/api/occasion/unread-count', { headers: { 'Authorization': 'Bearer ' + token } }),
        ]);
        let total = 0;
        if (r1.ok) { const d = await r1.json(); total += d.count || 0; }
        if (r2.ok) { const d = await r2.json(); total += d.count || 0; }
        setUnread(total);
      } catch {}
    };
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [user, location.pathname]);

  const active = (to) => {
    const [path, query] = to.split('?');
    if (location.pathname !== path) return false;
    if (!query) {
      // actif seulement si pas de tab dans l'URL courante (ou page simple)
      return true;
    }
    const want = new URLSearchParams(query).get('tab');
    const cur = new URLSearchParams(location.search).get('tab');
    return want === cur;
  };

  // Construire les items selon le rôle
  let items = [];
  if (user?.role === 'supplier') {
    items = [
      { to: '/fournisseur?tab=orders', icon: Package, label: 'Commandes' },
      { to: '/fournisseur?tab=boutique', icon: Store, label: 'Boutique' },
      { to: '/messages', icon: MessageSquare, label: 'Messages', badge: unread },
      { to: '/categories', icon: Search, label: 'Catalogue' },
      { to: '/', icon: Home, label: 'Accueil' },
    ];
  } else if (user?.role === 'admin') {
    items = [
      { to: '/', icon: Home, label: 'Accueil' },
      { to: '/categories', icon: Search, label: 'Catalogue' },
      { to: '/admin', icon: LayoutDashboard, label: 'Admin' },
      { to: '/messages', icon: MessageSquare, label: 'Messages', badge: unread },
      { to: '/panier', icon: ShoppingCart, label: 'Panier', badge: cartCount },
    ];
  } else {
    // Acheteur / visiteur
    items = [
      { to: '/', icon: Home, label: 'Accueil' },
      { to: '/categories', icon: Search, label: 'Rechercher' },
      { to: '/panier', icon: ShoppingCart, label: 'Panier', badge: cartCount },
      { to: user ? '/messages' : '/connexion', icon: MessageSquare, label: 'Messages', badge: unread },
      { to: user ? '/mes-commandes' : '/connexion', icon: user ? Package : User, label: user ? 'Commandes' : 'Compte' },
    ];
  }

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[#E8E0D0] flex items-stretch" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      {items.map((it, idx) => {
        const Icon = it.icon;
        const isActive = active(it.to);
        return (
          <Link key={idx} to={it.to}
            className={`flex-1 flex flex-col items-center justify-center py-2 relative ${isActive ? 'text-[#1F4D3F]' : 'text-[#9A8F82]'}`}>
            <div className="relative">
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} />
              {it.badge > 0 && (
                <span className="absolute -top-1.5 -right-2 bg-[#C75B27] text-white text-[9px] min-w-[15px] h-[15px] px-0.5 rounded-full flex items-center justify-center">{it.badge > 9 ? '9+' : it.badge}</span>
              )}
            </div>
            <span className="text-[9px] mt-0.5 font-medium">{it.label}</span>
            {isActive && <span className="absolute top-0 w-8 h-0.5 bg-[#1F4D3F] rounded-full" />}
          </Link>
        );
      })}
    </nav>
  );
};

export default BottomNav;
